import React from 'react'
import Header from '../components/layout/Header'
import Hero from '../components/sections/Hero'
import GoogleReviewsWidget from '../components/sections/GoogleReviewsWidget'
import AboutIntro from '../components/sections/about/AboutIntro'
import Results from '../components/sections/Results'
import Reels from '../components/sections/Reels'
import Approach from '../components/sections/about/Approach'
import Video from '../components/sections/about/Video'
import Trust from '../components/sections/Trust'
import Method from '../components/sections/Method'
import Process from '../components/sections/Process'
import Services from '../components/sections/Services'
import Contact from '../components/sections/Contact'
import ContactInfo from '../components/sections/ContactInfo'
import Footer from '../components/layout/Footer'
import JsonLd from '../components/utils/JsonLd'
import SEOHead from '../components/SEO/SEOHead'

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white text-dark-900">
      <SEOHead />
      <Header />
      <Hero />
      <main>
        <GoogleReviewsWidget />
        <AboutIntro />
        <Approach />
        <Video />
        <Trust />
        <Method />
        <Process />
        <Services />
        <Results />
        <Reels />
        <Contact />
        <ContactInfo />
        <Footer />
      </main>
      <JsonLd />
    </div>
  )
}
